import { Button, Dropdown } from '@/components';
import { SingleDateDropdown } from '@/components/SingleDateDropdown/SingleDateDropdown';
import {
  useAttachAutomationInfrastructureCost,
  useGetAllInfrastructureCostsByAutomationId,
} from '@/modules/Infrastructure/queries';
import { getDropdownArray } from '@/utils/get-dropdown-array.util';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type AssociateAutomationInfrastructureCostFormProps = {
  automationId: number;
  onCancel: () => void;
  onSubmit: () => void;
};

export const AssociateAutomationInfrastructureCostForm = ({
  automationId,
  onCancel,
  onSubmit,
}: AssociateAutomationInfrastructureCostFormProps) => {
  const { t } = useTranslation();
  const [selectedCostId, setSelectedCostId] = useState<number>();
  const [startDate, setStartDate] = useState<Date | undefined>();
  const [endDate, setEndDate] = useState<Date | undefined>();
  const { data: infrastructureCosts } =
    useGetAllInfrastructureCostsByAutomationId(automationId);

  const {
    mutate: attachAutomationInfrastructureCost,
    isLoading: isSubmitting,
  } = useAttachAutomationInfrastructureCost();
  return (
    <>
      <div className="mt-6 flex flex-col gap-5">
        <>
          <div className="flex flex-col gap-2">
            <div className="text-sm font-bold capitalize">
              {t('select_infrastructure_cost')}
            </div>
            <Dropdown
              className="h-10 w-full rounded-md bg-brightGray capitalize italic"
              placeholder={t('select_infrastructure_cost')}
              options={getDropdownArray(infrastructureCosts ?? [])}
              value={selectedCostId}
              onSelect={(option) => setSelectedCostId(option.value)}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div className="text-sm font-bold">
              {t('start_date')}
              <span className="font-medium">
                ({t('date_applied_automation')})
              </span>
            </div>
            <SingleDateDropdown
              placeholder={t('select_date')}
              onChange={setStartDate}
              date={startDate}
              className="h-10 w-full rounded-md bg-brightGray p-2 text-md capitalize italic"
            />
          </div>
          <div className="flex flex-col gap-2">
            <div className="text-sm font-bold">
              {t('end_date')}
              <span className="font-medium">
                ({t('date_not_applied_automation')})
              </span>
            </div>
            <SingleDateDropdown
              placeholder={t('select_date')}
              onChange={setEndDate}
              date={endDate}
              className="h-10 w-full rounded-md bg-brightGray p-2 text-md capitalize italic"
            />
          </div>
        </>
      </div>
      <div className="mt-8 flex justify-between">
        <Button
          isDisabled={isSubmitting}
          onClick={onCancel}
          variant="outline"
          className="h-9 w-24"
        >
          {t('cancel')}
        </Button>
        <Button
          isDisabled={isSubmitting}
          onClick={() => {
            if (selectedCostId) {
              attachAutomationInfrastructureCost({
                automationId,
                infrastructureCostId: selectedCostId,
                startDate,
                endDate,
              });
            }
            onSubmit();
          }}
          className="h-9 w-24"
        >
          {t('attach')}
        </Button>
      </div>
    </>
  );
};
